import React from "react";

export const ActivityIcon: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
      <circle cx="10" cy="10" r="8" stroke="currentColor" strokeWidth="2" fill="none" />
      <circle cx="10" cy="10" r="3" fill="currentColor" />
    </svg>
  );
};
